module.exports = __webpack_public_path__ + "img/Looc_Plug.76ab12ed.png";